import * as React from 'react';
import { Size } from '../../__types__/generated/cluster';

export const Area: React.FC<{ size?: Partial<Size> }> = ({
  size,
}) => {
  const formatSize = (from?: number, to?: number): JSX.Element | null => {
    if (!from) return null;
    let formattedSize = `${Math.trunc(from)}`;
    if (to && from < to) formattedSize += `-${Math.trunc(to)}`;
    formattedSize += 'm<sup>2</sup>';

    return (<span dangerouslySetInnerHTML={{ __html: formattedSize }} />);
  };

  if (size?.grossInternalArea || size?.grossInternalAreaTo) return formatSize(size.grossInternalArea, size.grossInternalAreaTo);
  if (size?.primaryArea || size?.primaryAreaTo) return formatSize(size.primaryArea, size.primaryAreaTo);
  if (size?.usableArea || size?.usableAreaTo) return formatSize(size.usableArea, size.usableAreaTo);
  if (size?.grossInternalArea) return formatSize(size.grossInternalArea);
  if (size?.primaryArea) return formatSize(size.primaryArea);
  if (size?.usableArea) return formatSize(size.usableArea);

  return null;
};